export default "__VITE_ASSET__DGq$_Ggv__"